import { links } from "@/constants/links";
import { http } from "../httpHandler";
import { TServerErrorResponse } from "@/types";

export const GET_PARAGON_JWT = "get-paragon-jwt";
export const PARAGON_SYNC_STATUS_KEY = "paragon-sync-status";

export const getParagonJwt = async (): Promise<string | undefined> => {
  try {
    const response = await http.get<string>(links.paragon.jwt);
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const updateUserCredentialConfig = async (
  jwt: string,
  credentialId: string,
  config: any,
): Promise<any | undefined> => {
  try {
    const response = await fetch(
      `https://api.useparagon.com/projects/${process.env.NEXT_PUBLIC_PARAGON_PROJECTID}/sdk/credentials/${credentialId}`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt}`,
        },
        body: JSON.stringify({ config }),
      },
    );
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(
        err?.message || `Paragon update failed (${response.status})`,
      );
    }
    return response.json();
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const getParagonSyncStatus = async (): Promise<
  Record<string, boolean>
> => {
  try {
    const response = await http.get<Record<string, boolean>>(
      links.paragon.syncStatus,
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
